import ArrowDownShape from "@themuse/design-system/lib/components/Icons/ArrowDownShape";
import SquareButton from "@themuse/design-system/lib/components/Buttons/SquareButton";
import styles from "./LoadMore.module.scss";

interface ILoadMore {
    shouldLoad: boolean;
    cb: () => void
}

/**
 * Renders the load more button if there are in fact more results to get.
 */
const LoadMore = (params: ILoadMore) => {
    const { shouldLoad, cb } = params;
    return shouldLoad
        ? (
            <SquareButton
                className={styles.loadMore}
                color="secondary-100"
                onClick={cb}
            >
                Load More Results
                <ArrowDownShape />
            </SquareButton>
        )
        : null;
};

LoadMore.displayName = "LoadMore";
export { LoadMore };
